/**
 * Reusable slide theme presets
 * Eliminates duplication of Tailwind classes across slide configurations
 */

// Common style presets
export const SLIDE_THEMES = {
  default: {
    outerBackgroundClass:
      "bg-gradient-to-br from-emerald-50 via-white to-slate-50 dark:from-slate-900 dark:via-slate-900/85 dark:to-slate-900",
    backgroundClass:
      "rounded-radius border border-white/30 bg-white/80 p-6 shadow-xl backdrop-blur-sm dark:border-slate-700/40 dark:bg-slate-900/70",
    frameClassName: "bg-transparent",
    imageWrapperClassName: "px-4",
    imageClassName: "object-cover",
    minHeightClass: "md:min-h-[480px]",
  },

  emerald: {
    outerBackgroundClass:
      "bg-gradient-to-br from-emerald-50 via-white to-nxstart-green/10 dark:from-slate-900 dark:via-slate-900/85 dark:to-slate-900",
    backgroundClass:
      "rounded-radius border border-white/30 bg-white/85 p-6 shadow-xl backdrop-blur-sm dark:border-slate-700/40 dark:bg-slate-900/70",
    frameClassName: "bg-transparent",
    imageWrapperClassName: "px-4",
    imageClassName: "object-cover",
    minHeightClass: "md:min-h-[460px]",
  },

  sky: {
    outerBackgroundClass:
      "bg-gradient-to-br from-white via-slate-50 to-emerald-100 dark:from-slate-900 dark:via-slate-900/85 dark:to-slate-900",
    backgroundClass:
      "rounded-radius border border-white/30 bg-white/80 p-6 shadow-xl backdrop-blur-sm dark:border-slate-700/40 dark:bg-slate-900/70",
    frameClassName: "bg-transparent",
    imageWrapperClassName: "px-4",
    imageClassName: "object-cover",
    minHeightClass: "md:min-h-[460px]",
  },

  skyBlue: {
    outerBackgroundClass:
      "bg-gradient-to-br from-slate-50 via-white to-sky-100 dark:from-slate-900 dark:via-slate-900/85 dark:to-slate-900",
    backgroundClass:
      "rounded-radius border border-white/30 bg-white/80 p-6 shadow-xl backdrop-blur-sm dark:border-slate-700/40 dark:bg-slate-900/70",
    frameClassName: "bg-transparent",
    imageWrapperClassName: "px-4",
    imageClassName: "object-cover",
    minHeightClass: "md:min-h-[480px]",
  },

  blueTint: {
    outerBackgroundClass:
      "bg-gradient-to-br from-white via-sky-50 to-nxstart-blue/10 dark:from-slate-900 dark:via-slate-900/85 dark:to-slate-900",
    backgroundClass:
      "rounded-radius border border-white/30 bg-white/85 p-6 shadow-xl backdrop-blur-sm dark:border-slate-700/40 dark:bg-slate-900/70",
    frameClassName: "bg-transparent",
    imageWrapperClassName: "px-4",
    imageClassName: "object-cover",
    minHeightClass: "md:min-h-[480px]",
  },

  amber: {
    outerBackgroundClass:
      "bg-gradient-to-br from-amber-50 via-white to-slate-50 dark:from-slate-900 dark:via-slate-900/85 dark:to-slate-900",
    backgroundClass:
      "rounded-radius border border-white/30 bg-white/80 p-6 shadow-xl backdrop-blur-sm dark:border-slate-700/40 dark:bg-slate-900/70",
    frameClassName: "bg-transparent",
    imageWrapperClassName: "px-4",
    imageClassName: "object-cover",
    minHeightClass: "md:min-h-[480px]",
  },

  amberEmerald: {
    outerBackgroundClass:
      "bg-gradient-to-br from-white via-amber-50 to-emerald-50 dark:from-slate-900 dark:via-slate-900/85 dark:to-slate-900",
    backgroundClass:
      "rounded-radius border border-white/30 bg-white/85 p-6 shadow-xl backdrop-blur-sm dark:border-slate-700/40 dark:bg-slate-900/70",
    frameClassName: "bg-transparent",
    imageWrapperClassName: "px-4",
    imageClassName: "object-cover",
    minHeightClass: "md:min-h-[460px]",
  },
};

// Color themes
export const COLOR_THEMES = {
  blue: {
    kickerClassName:
      "text-xs font-semibold uppercase tracking-[0.3em] text-nxstart-blue dark:text-nxstart-origin",
    titleColorClass: "text-nxstart-blue dark:text-nxstart-origin",
  },

  blueEmerald: {
    kickerClassName:
      "text-xs font-semibold uppercase tracking-[0.3em] text-nxstart-blue dark:text-emerald-200",
    titleColorClass: "text-nxstart-blue dark:text-emerald-200",
  },

  green: {
    kickerClassName:
      "text-xs font-semibold uppercase tracking-[0.3em] text-nxstart-green",
    titleColorClass: "text-nxstart-green",
  },

  amber: {
    kickerClassName:
      "text-xs font-semibold uppercase tracking-[0.3em] text-amber-600 dark:text-amber-200",
    titleColorClass: "text-amber-600 dark:text-amber-200",
  },
};

// Common defaults
export const SLIDE_DEFAULTS = {
  layout: "split",
  titlePlacement: "center",
};

/**
 * Helper to merge theme with slide data
 */
export const applyTheme = (slide, theme = "default", colorTheme = "green") => ({
  ...SLIDE_DEFAULTS,
  ...SLIDE_THEMES[theme],
  ...COLOR_THEMES[colorTheme],
  ...slide,
});
